import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Settings.module.scss';
import Modal from 'react-responsive-modal';

/**
 * Import components
 */
import Menu from 'components/UI/Menu/Menu';
import Popup from 'components/UI/Popup/Popup';
import TimeslotSettings from 'components/UI/Popup/TimeslotSettings/TimeslotSettings';
import DropDown from 'components/UI/DropDown/DropDown';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logoutUser from 'actions/authentication/logout';
import updateUser from 'actions/user/update';

const mapDispatchToProps = {
    logoutUser,
    updateUser
};

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user
    };
};

class Settings extends Component {

    constructor() {
        super();

        this.state = {
            showMenu: false,
            use_timer: true,
            show_hours: false,
            modalOpen: false,
            amount_of_cards: 8,
        };

        this.switchMenu                         = this.switchMenu.bind(this);
        this.handleUseTimerChange               = this.handleUseTimerChange.bind(this);
        this.closeModal                         = this.closeModal.bind(this);
        this.openModal                          = this.openModal.bind(this);
        this.updateHours                        = this.updateHours.bind(this);
        this.toggleHoursSetting                 = this.toggleHoursSetting.bind(this);
        this.updateUser                         = this.updateUser.bind(this);
        this.updateAmountOfCards                = this.updateAmountOfCards.bind(this);

        this.defaultTimes = { '1': [ 9, 0, 10, 0 ], '2': [ 10, 0, 11, 0 ], '3': [ 11, 0, 12, 0 ], '4': [ 12, 0, 13, 0 ], '5': [ 13, 0, 14, 0 ], '6': [ 14, 0, 15, 0 ], '7': [ 15, 0, 16, 0 ], '8': [ 16, 0, 17, 0 ], '9': [ 17, 0, 18, 0 ], '10': [ 18, 0, 19, 0 ]};

    }

    componentDidMount() {
        this.setState({
            name: this.props.user.name,
            email: this.props.user.email,
            use_timer: this.props.user.use_timer,
            times: this.props.user.times,
            show_hours: this.props.user.show_hours,
            amount_of_cards: this.props.user.amount_of_cards
        });
    }

    handleUseTimerChange(event) {
        this.setState({ use_timer: event.target.checked });
    }

    switchMenu(e) {
        this.state.showMenu ? this.setState({ showMenu: false }) : this.setState({ showMenu: true });
    }

    updateUser() {
        this.props.updateUser({
            ...this.state,
            id: this.props.user.id,
        }).then((result) => {
            alert('Gebruiker bijgewerkt');
            this.props.history.push('/agenda');
        })
            .catch((error) => {
                if (error.response.data && error.response.data.errors && error.response.data.errors.password) {
                    return alert('Wachtwoord wijzigen mislukt: huidig wachtwoord onjuist of nieuw wachtwoord voldoet niet aan de eisen. Probeer aub opnieuw');
                }

                alert('Er ging iets mis met het bijwerken van je account. Probeer aub opnieuw');
            });
    }

    toggleHoursSetting(event) {

        //check if show_hours is being set to 1 and the times array is still empty. In that case we set the default values.
        if (this.state.show_hours == 0 && this.state.times == null) {
            this.setState({ times: this.defaultTimes });
        }

        this.setState({ show_hours: !this.state.show_hours });
    }

    updateHours(hours) {
        this.setState({ times: hours });
    }

    updateAmountOfCards(event) {
        let newValue = event.target.value;

        if(newValue < this.props.user.amount_of_cards) {
            if(confirm('Let op, als je het aantal lesuren verminderd gaan alle vakken op die periodes verloren! Wil je doorgaan?')) {
                this.setState({amount_of_cards: newValue});
            }
        } else {
            this.setState({amount_of_cards: newValue});
        }
    }

    closeModal() {
        this.setState({ modalOpen: false });
    }

    openModal() {
        this.setState({ modalOpen: true });
    }

    render() {
        return (
            <div styleName="profile-background">
                <div styleName='hamburger-icon' onClick={this.switchMenu}><FontAwesomeIcon styleName='icon' icon={[ 'far', 'bars' ]}/>
                </div>
                <Popup handleClose={this.switchMenu} visible={this.state.showMenu} click={this.switchMenu}>
                    <Menu handleClose={this.switchMenu} open={this.state.showMenu} click={this.switchMenu}/>
                </Popup>

                <Modal open={this.state.modalOpen} onClose={this.closeModal} center styles={{
                    modal: {
                        boxShadow: 'none',
                        background: 'none',
                        padding: '10px',
                        borderRadius: '6px', 
                    },
                    closeButton: {
                        fill: '#fff',
                        cursor: 'pointer',
                        position: 'absolute',
                        top: '6px',
                        right: '7px'
                    }
                }}>
                    <TimeslotSettings hours={this.state.times} amountOfCards={this.state.amount_of_cards} saveHours={this.updateHours} handleClose={this.closeModal}/>
                </Modal>

                <div styleName="top-bar">
                    <h1 styleName="title" >Instellingen</h1>
                </div>
                <div styleName="content">

                    <form styleName="register-form">
                        <h4>Plenda Tracker</h4>
                        <input id="timer" styleName="input-box" type="checkbox" 
                            checked={this.state.use_timer} onChange={this.handleUseTimerChange} />
                        <label htmlFor="timer">Gebruik tijdsindicatie</label>
                        <h4 style={{ marginTop: '15px' }}>Tijdsweergave agenda</h4>
                        <div styleName='timesettings-wrapper'>
                            <div>
                                <DropDown borderRadius='5px' height="30px" lightborder>
                                    <select onChange={this.updateAmountOfCards} value={this.state.amount_of_cards}>
                                        <option value='8'>8 lesuren</option>
                                        <option value='9'>9 lesuren</option>
                                        <option value='10'>10 lesuren</option>
                                    </select>
                                </DropDown>
                            </div>
                            <div>
                                <input id="lesuren" styleName="input-box" type="checkbox" 
                                    checked={!this.state.show_hours} onChange={this.toggleHoursSetting} />
                                <label htmlFor="lesuren">Lesuren: op volgorde genummerd</label>
                            </div>
                            <div>
                                <input id="hours" styleName="input-box" type="checkbox" 
                                    checked={this.state.show_hours} name='hours' onChange={this.toggleHoursSetting} />
                                <label htmlFor="hours">Lestijden: met tijdsaanduiding</label>
                            </div>
                            <div styleName='set-timeslots' onClick={this.openModal}>
                                <p>Lestijden instellen</p>
                            </div>
                        </div>
                    </form>
                    
                    <div styleName="actions">
                        <p onClick={this.updateUser}>Opslaan</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);